import StackAPI from '@/lib/StackAPI'

export interface ResetOrgUserPasswordParams {
  token: string
  password: string
  recaptchaToken: string | null
}

const ENDPOINT = '/org_users/submit_password_reset'

export const resetOrgUserPassword = async ({
  token,
  password,
  recaptchaToken
}: ResetOrgUserPasswordParams) => {
  const { post } = StackAPI()

  const request = {
    path: ENDPOINT,
    params: {
      token,
      password,
      recaptcha_token: recaptchaToken
    },
    headers: {
      'Content-Type': 'application/json'
    }
  }

  return await post(request)
    .then((response) => {
      if (response.status !== 200) {
        throw new Error('Failed to reset password')
      }
      return response.data
    })
    .catch((error) => {
      throw new Error(error.message || 'Failed to reset password')
    })
}
